"use client";
import { useState, useCallback } from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

import { setPhoneGa4EventToService } from "services/event";

import { phoneFormatter } from "helpers/phone-formatter";
import { GTMPushEvent } from "@/src/helpers/google-tag-manager";
import { runIdle } from "@/src/utils/idle-utils";

import Button from "components/common/button";

import styles from "./styles.module.css";

const ShowPhone = ({
  phoneNumber = "",
  isTextView = false,
  listItemInfo,
  gtmEventLabel,
  componentFlag,
  hasGreenBackground,
  statusCode,
}) => {
  const [isShowPhone, setIsShowPhone] = useState(false);

  const handleShowPhoneButton = useCallback((e) => {
    e.preventDefault();

    setTimeout(() => {
      setIsShowPhone(true);
    }, 0);

    runIdle(() => {
      setga4PhoneEvent();
    }, 1000);
  }, []);

  // will remove after the branch merge to dev
  const trMap = {
    çÇ: "c",
    ğĞ: "g",
    şŞ: "s",
    üÜ: "u",
    ıİ: "i",
    öÖ: "o",
  };

  const decodeTurkishCharacters = (text) => {
    if (typeof text !== "string") return undefined;
    return Object.keys(trMap).reduce((acc, key) => acc.replace(new RegExp("[" + key + "]", "g"), trMap[key]), text);
  };

  function slugify(text) {
    const decodedText = decodeTurkishCharacters(text);
    if (!decodedText) return undefined;
    return decodedText
      .replace(/[^-a-zA-Z0-9\s]+/gi, "") // remove non-alphanumeric chars
      .replace(/\s/gi, "-") // convert spaces to dashes
      .replace(/[-]+/gi, "-") // trim repeated dashes
      .toLowerCase();
  }

  const checkName = (str) => {
    if (!str) return undefined;
    return slugify(str);
  };

  const checkPrice = (p) => {
    if (p?.price) return p.price.toString();
    if (p?.tlPrice) return p.tlPrice.toString();
    return undefined;
  };

  const setga4PhoneEvent = () => {
    const eventName = isShowPhone ? "call" : "view_phone";
    const itemType = "ilan";
    const { priceDetail, location, id, owner } = listItemInfo || {};

    const pageTypeEquals = {
      listeleme: "ilan-listeleme",
      emlak_ofisleri: "ilan-listeleme",
      detay: "ilan-detay",
      galeri_detay: "galeri-header",
      gallery_last_photo: "galeri",
    };
    const pageTypeForGa4Event = pageTypeEquals[gtmEventLabel] || gtmEventLabel;
    const isListingDetailPage = ["ilan-detay", "galeri-header"].includes(pageTypeForGa4Event);

    const ownerSource = isListingDetailPage ? owner?.account : owner;
    const { id: ownerId, name: ownerName, type: ownerType, businessName: ownerBusinessName } = ownerSource || {};

    GTMPushEvent({
      event: "ga4_event",
      event_name: eventName,
      event_parameters: {
        ...((!isShowPhone || componentFlag === "suggestedListings") && { view_count: 1 }),
        page_type: pageTypeForGa4Event,
        ...(componentFlag !== "suggestedListings" &&
          componentFlag !== "similarListings" && {
            ilan_fiyat: checkPrice(priceDetail),
          }),
        item_id: id?.toString(),
        item_type: itemType,
        city: checkName(location?.city?.name),
        town: checkName(location?.district?.name),
        neighborhood: checkName(location?.town?.name),
        district: checkName(location?.locality?.name),
        ...(ownerId && { ilan_uye_id: String(ownerId) }),
        ...((isListingDetailPage ? ownerBusinessName === "Emlak" && ownerName : ownerName) && {
          ilan_emlakci: slugify(ownerName),
        }),
        ...(ownerType && {
          ilan_uye_tip: ownerType === "corporate" ? "kurumsal" : "bireysel",
        }),
      },
    });

    if (!isShowPhone) {
      try {
        setPhoneGa4EventToService({
          listingId: id,
          eventName,
          reason: gtmEventLabel === "detay" ? "listing_detail" : "listing_list",
        });
      } catch (error) {
        console.error("Error from show phone sending event: ", error);
      }
    }
  };

  const buttonClass = classNames({
    [styles.buttonClass]: true,
    [styles.isTextView]: isTextView,
  });

  const linkClass = classNames({
    [styles.greenPhoneLink]: hasGreenBackground,
    [styles.phoneLink]: !hasGreenBackground && gtmEventLabel !== "detay",
    [styles.phoneLinkDetail]: !hasGreenBackground && gtmEventLabel === "detay",
  });

  return (
    <div className={buttonClass}>
      {isShowPhone ? (
        <a href={`tel:${phoneNumber}`} onClick={setga4PhoneEvent} className={linkClass}>
          {phoneFormatter(phoneNumber)}
        </a>
      ) : (
        <Button size={statusCode ? "S" : "M"} onClick={(e) => handleShowPhoneButton(e)}>
          Telefona Bak
        </Button>
      )}
    </div>
  );
};

ShowPhone.propTypes = {
  phoneNumber: PropTypes.string,
  isTextView: PropTypes.bool,
  listItemInfo: PropTypes.object,
  gtmEventLabel: PropTypes.string,
  componentFlag: PropTypes.string,
  hasGreenBackground: PropTypes.bool,
  statusCode: PropTypes.bool,
};

export default ShowPhone;
